import React from 'react';
import { Quote } from 'lucide-react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      quote: "ProSolve gave me the structure and stability I needed to focus on recovery and rebuild my life.",
      author: "Former Resident",
      program: "Men's Recovery House",
    },
    {
      id: 2,
      quote: "The supportive environment and accountability helped me stay on track. I'm grateful for the opportunity to rebuild my life in a safe space.",
      author: "Former Resident",
      program: "Women's Recovery House",
    },
    {
      id: 3,
      quote: "Finding a place that understood my journey and provided the structure I needed made all the difference in my recovery.",
      author: "Current Resident",
      program: "Men's Recovery House",
    },
  ];

  return (
    <div className="testimonials-page">
      <section className="page-hero">
        <div className="hero-container">
          <h1 className="page-title">Testimonials</h1>
          <p className="page-subtitle">Stories from Our Community</p>
        </div>
      </section>

      <section className="page-content">
        <div className="content-container">
          <div className="testimonials-intro">
            <p className="intro-text">
              We welcome feedback from residents, families, and community partners who have worked with ProSolve Global Solutions Recovery Houses.
            </p>
            <p className="intro-text">
              Testimonials help others understand the impact of structured recovery housing and the importance of stable environments in recovery.
            </p>
          </div>

          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <Quote size={48} className="quote-icon" />
                <blockquote className="testimonial-quote">
                  {testimonial.quote}
                </blockquote>
                <div className="testimonial-footer">
                  <p className="testimonial-author">{testimonial.author}</p>
                  <p className="testimonial-program">{testimonial.program}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="share-testimonial">
            <h2 className="share-title">Share Your Story</h2>
            <p className="share-text">
              If you or a loved one has been impacted by our recovery housing programs, we'd love to hear from you. Your story can inspire and encourage others on their recovery journey.
            </p>
            <div className="share-contact">
              <p className="contact-label">Contact us to share your testimonial:</p>
              <div className="contact-methods">
                <a href="tel:610-443-0175" className="contact-method">
                  Call: 610-443-0175
                </a>
                <a href="mailto:Admin@prosolveglobalsolutions.com" className="contact-method">
                  Email: Admin@prosolveglobalsolutions.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
